import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class ReportsPresentTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.REPORTS_PRESENT;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLE_REPORTS_PRESENT;

	get id(): string {
		return TourId.REPORTS__PRESENT;
	}

	override get keyForPersistantDone(): string {
		return ReportsPresentTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.DOWN,
				allowStacked: false,
				attachTo: () => {
					// Target the Present button in the header
					return $('#report-editor_head .present');
				},
				scrollToAttachTo: true,
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}

	override onExplicitClose(): void {
		this.flowTourReportsSlidesService.endAllTours();
		super.onExplicitClose();
	}
}
